<template>
  <div class="login-layout blur-login">
  <div class="main-container">
    <div class="main-content">
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="login-container">
            <div class="position-relative">
              <div id="login-box" class="login-box visible widget-box no-border">
                <div class="widget-body">
                  <div class="widget-main">
                    <h4 class="header blue lighter bigger">
                      <img :src="logo" alt="logo" />
                    </h4>
                    <h1 class="notice-title" v-if="env !== 'production' && env !== 'spc1'">{{env}}</h1>
                    <div class="alert alert-danger" v-if="error">
                      {{ error }}
                    </div>
                    <form @submit.prevent="validateBeforeSubmit">
                      <fieldset>
                        <label class="block clearfix">
                          <span v-show="errors.has('ownerId')" class="error">{{ errors.first('ownerId') }}</span>
                          <span class="block input-icon input-icon-right">
                            <input :class="{ error: errors.has('ownerId') }" name="ownerId" type="text" class="form-control" v-validate="'required'"  placeholder="事業者ID" v-model="credentials.ownerId" data-vv-as="名前"/>
                          </span>
                        </label>
                        <label class="block clearfix">
                          <span v-show="errors.has('userId')" class="error">{{ errors.first('userId') }}</span>
                          <span class="block input-icon input-icon-right">
                            <input :class="{ error: errors.has('userId') }" v-validate="'required'" name="userId" type="text" class="form-control" placeholder="ユーザーID" v-model="credentials.userId"/>
                          </span>
                        </label>
                        <label class="block clearfix">
                          <span v-show="errors.has('password')" class="error">{{ errors.first('password') }}</span>
                          <div class="block input-icon input-icon-right" style="display:inline-block!important;width:90%">
                            <input :class="{ error: errors.has('password') }" id="password" v-validate="'required'" name="password" type="password" class="form-control" placeholder="パスワード" v-model="credentials.password"/>
                          </div>
                          <div class="newpassword-showhide" style="display:inline-block">
                            <span class="show-password" @click="showhidePassword('password' , 'show-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_off.png" width="30"></span>
                            <span class="hide-password" @click="showhidePassword('password' , 'hide-password' , 'newpassword-showhide')"><img src="../../../static/img/eye_on.png" width="30"></span>
                          </div>
                        </label>
                        <div class="space"></div>
                        <div class="clearfix login-button">
                          <button type="submit" class="width-60">
                            <i class="glyphicon glyphicon-log-in"></i>
                            <span class="bigger-110 login-text">ログイン</span>
                          </button>
                        </div>
                        <div class="forgot-password-link">
                          <router-link tag="a" :to="{ name: 'forgotpassword'}" class="forgot-password-link">
                            <i class="ace-icon fa fa-arrow-right"></i>
                            パスワードが分からない場合
                          </router-link>
                        </div>
                      </fieldset>
                    </form>
                  </div><!-- /.widget-main -->
                </div><!-- /.widget-body -->
              </div><!-- /.login-box -->
            </div><!-- /.position-relative -->
          </div>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.main-container -->
  </div>
</template>

<script>
export default {
  name: 'login',

  data () {
    return {
      env: process.env.NODE_ENV,
      logo: process.env.LOGO_IMAGE,
      credentials: {
        ownerId: '',
        userId: '',
        password: ''
      },
      error: ''
    }
  },
  methods: {
    showhidePassword (passwordId, classname, buttonname) {
      if (classname === 'show-password') {
        $('#' + passwordId).attr('type', 'text')
        $('.' + buttonname).find('.show-password').hide()
        $('.' + buttonname).find('.hide-password').show()
      } else {
        $('#' + passwordId).attr('type', 'password')
        $('.' + buttonname).find('.hide-password').hide()
        $('.' + buttonname).find('.show-password').show()
      }
    },
    removeLoading () {
      $('#loading').remove()
    },
    dispLoading () {
      $('.main-content').append('<div id="loading"><div class="loadingMsg"></div></div>')
    },
    submit () {
      this.dispLoading()
      const credentials = {
        ownerId: this.credentials.ownerId,
        userId: this.credentials.userId,
        password: this.credentials.password
      }
      this.$auth.login(this, credentials, 'dashboard')
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit()
        }
      })
    }
  }
}
</script>

<style>
.login-button button {
    outline: inherit;
}
body{
  background: #394557
}
#loading {
  display: table;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999
}
#loading .loadingMsg {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  width: 45px;
  height: 45px;
  background: url('../../../static/img/loading.gif') center center no-repeat;
  background-size: 100px 100px;
}
span.error {
  color: red;
}
input {
  border: 1px solid black;
}
input.error {
  border: 1px solid red;
}
</style>



// WEBPACK FOOTER //
// src/views/login/Index.vue